
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
name: 'alliance_petinfo',
components: {
Group, PopupPicker, Datetime
},
data() {
return {
title: '宠物信息',
name: "",//宠物昵称
site: 1,//默认宠物类型 1狗 2猫
gender: 1,//默认宠物性别 1公 2母
pid: this.$route.query.pid,//宠物id
dogList: [],//狗品种列表
catList: [],//猫品种列表
breed_id: "",//品种id
dog_name: [],//狗名称
cat_name: [],//猫名称
birthday: "",//出生日期
endDate: this.get_date(),//最大日期时间
isDisabled: true,
url: window.location.href,//当前地址
}
},
computed: {
isdisabledFn() {
var self = this;
if (self.name != "" && self.breed_id != "" && self.birthday != "") {
return self.isDisabled = false;
} else {
return self.isDisabled = true;
}
}
},
created() {
if (sessionStorage.getItem('token') == null) {
this.get_token(this.url);
}
else{
if (this.pid) {
this.get_pet();
} else {

this.get_breed();
}
}

},

methods: {

get_token(url) {
var self = this;
this.$EpetJs.Common.approve(url, function () {

if (self.pid) {
self.get_pet();
} else {

self.get_breed();
}
}) //获取token

},

changeType(type) {
this.site = type;
this.get_breed();
},

changeSex(sex) {
this.gender = sex;
},

breed_change(val) {
this.breed_id = val[0];
},

birth_change(value) {
this.birthday = value;
},

get_pet() {
var self = this;
this.$EpetJs.Common.get("public/user/pets/" + this.pid, {}).then(({ data }) => {
if (data.status_code == '200') {
var petInfo = data.data[0];
self.name = petInfo.pt_name;
self.site = petInfo.pt_type;
self.gender = petInfo.pt_sex;
self.birthday = self.get_date(petInfo.pt_birth);
self.breed_id = petInfo.pt_id;
if (self.site == 1) {
self.dog_name = (petInfo.pt_id).toString().split();
}
else {
self.cat_name = (petInfo.pt_id).toString().split();
}
self.get_breed();
}
})
},

get_date(value) {
var date = new Date();
var y = "";
var m = "";
var d = "";
if (value) {//出生日期转换
date = new Date(value * 1000);
}
y = date.getFullYear();
m = date.getMonth() + 1;
d = date.getDate();
if (m < 10) {
m = '0' + m;
}
if (value) {//出生日期转换
return y + '-' + m
} else {//最大日期
return y + '-' + m + '-' + d
}
},

get_breed() {
var self = this;
this.$EpetJs.Common.get("public/user/pet/breeds?site=" + this.site, {}).then(({ data }) => {
if (data.status_code == '200') {
if (self.site == 1) {
self.dogList = data.data;
} else if (self.site == 2) {
self.catList = data.data;
}

}
})
},

update_pet(pid) {
var self = this;
self.isDisabled = false;
var urlValue = self.$EpetJs.Helper.createApiUrl("public/user/pets/" + pid);
self.$EpetJs.Helper.ajaxRequest(urlValue, { name: this.name, gender: this.gender, type: this.site, breed_id: this.breed_id, birthday: this.birthday }, 'put').then(({ data }) => {
if (data.status_code == 200) {
this.$router.push({ name: 'alliance_personal' })
} else {
self.$vux.toast.text(data.message);
}
})
},

add_pet() {
var self = this;
this.$EpetJs.Common.post("public/user/pets", { name: this.name, gender: this.gender, type: this.site, breed_id: this.breed_id, birthday: this.birthday }).then(({ data }) => {
if (data.status_code == '200') {
self.$router.push({ name: 'alliance_personal' })
}
else {
self.$vux.toast.text(data.message);
}
})
},
},

}
